/* eslint-disable */
import axios from "axios"

export default {
  methods: {
    /**
     * Traz combo de Transplante
     * @param {Number} id
     * @return {
     *   "Transplante": [
     *   {
     *    "id": 0,
     *    "tipoTransplante": "string"
     *   }
     *  ]
     * }
     */
    getTransplante(form_name) {
      return axios.get(
        this.CriarUrl({
          resource: `transplante?rnpTipoFormulario=${form_name}`
        })
      );
    },
  }
}